import React from 'react';
import PropTypes from 'prop-types';
import styles from "./styles.module.scss";

const PolicyListItem = ({
                           label,
                           icon
                         }) => {

  return (
    <div className={styles.itemContainer}>
      <img
        src={icon}
        alt="arrow"
        className={styles.arrow}
      />
      <div>
        {label}
      </div>
    </div>
  )
};

PolicyListItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.any,
};

export default PolicyListItem;
